import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';
import { wrapFetch } from '#/fetch-wrapper';


/*
* AMENITY TYPES
*/


const fetchAmenityTypes = () => wrapFetch(() => api.get('/amenity-types'));
const createAmenityTypes = payload => wrapFetch(() => api.post('/amenity-types', payload));
const deleteAmenityTypes = (tag, type) => wrapFetch(() => api.delete(`/amenity-types/${tag}/${type}`));

const updateAmenityTypes = payload => wrapFetch(() => api.put('/amenity-types', payload));


export const useAmenityTypes = (queryOptions = {}) => useQuery(['amenity-types'], () => fetchAmenityTypes(), queryOptions);
export const useDeleteAmenityTypes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ tag, type }) => deleteAmenityTypes(tag, type), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-types');
        },
        ...queryOptions
    });
};

export const useCreateAmenityTypes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createAmenityTypes(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-types');
        },
        ...queryOptions
    });
};

export const useUpdateAmenityTypes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({
        payload
    }) => updateAmenityTypes(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-types');
        },
        ...queryOptions
    });
};
